export default [
    { code: 'en', name: 'English' }, // english
    { code: 'de', name: 'Deutsch' }, // german
    { code: 'es', name: 'Español' }, // spanish
    { code: 'fr', name: 'Français' }, // french
    { code: 'it', name: 'Italiano' }, // italian
    { code: 'ja', name: '日本語' }, // japanese
    { code: 'ko', name: '한국어' }, // korean
    { code: 'nl', name: 'Nederlands' }, // dutch
    { code: 'no', name: 'Norsk' }, // norwegian
    { code: 'pl', name: 'Polski' }, // polish
    { code: 'ru', name: 'Русский' }, // russian
    { code: 'zh', name: '简体中文' }, // chinese
] as const;
